/**
 * Options for MultiSelectDropdown (value/label strings).
 * Includes orphan ids (selected but not in `availableOrgs`) so chips stay valid.
 *
 * @param {{ id: number|string }[]} availableOrgs
 * @param {number[]} selectedOrgIds
 * @param {(id: number) => string} [orphanLabel] - label for ids not in availableOrgs
 */
export function buildOrgMultiSelectOptions(availableOrgs, selectedOrgIds, orphanLabel) {
  const ids = selectedOrgIds || [];
  const list = Array.isArray(availableOrgs) ? availableOrgs : [];
  const apiIds = new Set(list.map((o) => Number(o.id)));
  const orphans = ids.filter((id) => !apiIds.has(Number(id)));
  const base = list.map((o) => ({ value: String(o.id), label: o.name }));
  const labelFn =
    orphanLabel ||
    ((id) => `Org ${id} (id ${id})`);
  const extra = orphans.map((id) => ({
    value: String(id),
    label: labelFn(id),
  }));
  return [...base, ...extra];
}

/** Map MultiSelectDropdown string values to numeric org ids (same order as UI). */
export function parseOrgIdsFromMultiSelectValues(stringValues) {
  return (stringValues || [])
    .map((v) => Number(v))
    .filter((n) => !Number.isNaN(n));
}
